import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import ReactDOM from "react-dom";
import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserData } from "./const";
import "../assets/css/theme-table-header.css";
import {
  collectOldMetalFieldErrors,
  lineCellErrorStyle,
  pruneLineFieldErrors,
} from "../utils/lineItemFieldErrors";
import { getSessionBranchId } from "../utils/sessionBranch";
import { toast } from "react-hot-toast";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import {
  sanitizeMobileInput,
  mobileInputFieldProps,
} from "../utils/mobileInput";
import {
  editOldMetalPurchase,
  listBankAccounts,
  listOldMetalPurchases,
  showOldMetalPurchaseById,
} from "../erpClient";
import {
  createOldMetalIdempotencyKey,
  isOldMetalApiSuccess,
  mapOldMetalShowToLegacyCached,
  normalizeOldMetalListRows,
  pickOldMetalShowDocument,
} from "../utils/oldMetalPurchaseErpAdapter";
import {
  buildStandardPaymentLines,
  mapApiPaymentsToUiRows,
} from "../utils/paymentLinesErpAdapter";
import { handleRoundOffInputChange } from "../utils/roundOffInput";
import { autoRoundOff } from "../utils/autoRoundOff";
import {
  fetchProductGroupOptionById,
  mergeProductGroupOptions,
  searchProductGroupSelectOptions,
  productGroupOptionDisplayName,
} from "../utils/productGroupOptions";
import { numPool } from "../utils/productGroupPool";
import ProductGroupPoolBalance from "../components/ProductGroupPoolBalance";
import PaymentSection, {
  PAYMENT_METHOD_LABELS,
} from "../components/PaymentSection";
import {
  setupPortalContainers,
  teardownPortalContainers,
} from "../utils/portalContainers";

const DEFAULT_BILL_LABEL = "GST";

const URD_EXCLUDED_PAY_MODES = ["old_gold", "old_silver", "kasar", "scheme"];

const createDefaultSettlementRows = () => [
  {
    id: 1,
    paymentId: null,
    pay_mode: "cash",
    type: "",
    remarks: "",
    amount: "",
  },
  {
    id: 2,
    paymentId: null,
    pay_mode: "upi",
    type: "",
    remarks: "",
    amount: "",
  },
  {
    id: 3,
    paymentId: null,
    pay_mode: "bank_transfer",
    type: "",
    remarks: "",
    amount: "",
  },
];

const parseNumericValue = (value) => {
  if (value === "" || value === null || value === undefined) return 0;
  const num = parseFloat(String(value).replace(/,/g, ""));
  return isNaN(num) ? 0 : num;
};

function EditOldPurchase({
  masterGoldRate = 0,
  masterSilverRate = 0,
  showLiveRate = false,
  purchaseId: purchaseIdProp,
  purchaseNo: purchaseNoProp,
  onClose,
  viewOnly = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const isEmbedded = typeof onClose === "function";
  const isViewOnly = Boolean(viewOnly) || isEmbedded;
  const leaveEdit = () => {
    if (isEmbedded) {
      onClose();
      return;
    }
    navigate("/metalpurchasetable");
  };
  const purchaseId =
    purchaseIdProp ||
    location.state?.purchaseId ||
    location.state?.id ||
    searchParams.get("purchaseId") ||
    searchParams.get("id");
  const purchaseNo =
    purchaseNoProp ||
    location.state?.purchaseNo ||
    location.state?.purchase_no ||
    location.state?.docNumber ||
    searchParams.get("purchaseNo") ||
    searchParams.get("docNumber");
  const [selectedDate, setSelectedDate] = useState("");
  const { buttonClass, cardClass, buttonTableStyle } = useButtonTableStyle();

  // Bill type states
  const [billTypes, setBillTypes] = useState([]);
  const [billTypeSearchText, setBillTypeSearchText] =
    useState(DEFAULT_BILL_LABEL);
  const [billTypeDropdownActive, setBillTypeDropdownActive] = useState(false);
  const [billTypeHighlightedIndex, setBillTypeHighlightedIndex] = useState(-1);
  const [billType, setBillType] = useState(null);
  const billTypeInputRef = useRef(null);
  const billTypeDropdownRef = useRef(null);
  const billTypeItemsRef = useRef([]);

  // Customer selection states (like Sales.jsx)
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerMobileSearchText, setCustomerMobileSearchText] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerNameSearchText, setCustomerNameSearchText] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [customerMobileDropdownActive, setCustomerMobileDropdownActive] =
    useState(false);
  const [customerNameDropdownActive, setCustomerNameDropdownActive] =
    useState(false);
  const [customerMobileHighlightedIndex, setCustomerMobileHighlightedIndex] =
    useState(0);
  const [customerNameHighlightedIndex, setCustomerNameHighlightedIndex] =
    useState(0);
  const customerMobileInputRef = useRef(null);
  const customerNameInputRef = useRef(null);
  const customerMobileDropdownRef = useRef(null);
  const customerNameDropdownRef = useRef(null);
  const customerMobileItemsRef = useRef([]);
  const customerNameItemsRef = useRef([]);
  const userData = getUserData();
  const [userss, setUserss] = useState([]);
  const [tableRows, setTableRows] = useState([
    {
      id: 1,
      itemId: null,
      product_group_id: "",
      pcs: "",
      ct: "",
      gwt: "",
      lwt: "",
      nwt: "",
      touch: "",
      fine_wt: "",
      total_amt: "",
      isTotalAmtManual: false, // Flag to track if total_amt was manually edited
    },
  ]);
  const [itemFieldErrors, setItemFieldErrors] = useState({});

  useEffect(() => {
    setItemFieldErrors((prev) =>
      pruneLineFieldErrors(prev, collectOldMetalFieldErrors(tableRows)),
    );
  }, [tableRows]);

  const [bankAccounts, setBankAccounts] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentRows, setPaymentRows] = useState(createDefaultSettlementRows);
  const [payableRows, setPayableRows] = useState([
    { id: 1, pay_mode: "cash", type: "", remarks: "", amount: "" },
  ]);
  const [note, setNote] = useState("");
  const [followUpDate, setFollowUpDate] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [roundOffAmount, setRoundOffAmount] = useState("");
  const [isManualRoundOff, setIsManualRoundOff] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [gstPercentage, setGstPercentage] = useState("");
  const [customerState, setCustomerState] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerArea, setCustomerArea] = useState("");
  const [productGroupOptionsCache, setProductGroupOptionsCache] = useState([]);
  const [productGroupRowResults, setProductGroupRowResults] = useState({});
  const [productGroupSearchLoading, setProductGroupSearchLoading] = useState(
    {},
  );
  const [productGroupApiCalled, setProductGroupApiCalled] = useState({});
  const [productGroupDropdownActive, setProductGroupDropdownActive] =
    useState({});
  const [productGroupSearchText, setProductGroupSearchText] = useState({});
  const [productGroupHighlightedIndex, setProductGroupHighlightedIndex] =
    useState({});
  const productGroupInputRefs = useRef({});
  const productGroupDropdownRefs = useRef({});
  const productGroupItemsRefs = useRef({});
  const lastSearchedProductGroupPrefixRef = useRef({});
  const productGroupSearchTimerRef = useRef({});
  const tableContainerRef = useRef(null);
  const [productGroupPoolHeader, setProductGroupPoolHeader] = useState(null);
  const [customerCity, setCustomerCity] = useState("");
  const [customerSaleBalance, setCustomerSaleBalance] = useState("");

  const hasFetchedPurchase = useRef(false);
  const hasFetchedBanks = useRef(false);
  const oldMetalUpdateIdempotencyKeyRef = useRef(null);
  const oldMetalUpdateFingerprintRef = useRef(null);

  // Load purchase data for editing
  // Listen for API URL changes - navigate back to table
  useEffect(() => {
    const handleApiUrlChange = (event) => {
      console.log('API URL changed in EditOldPurchase, navigating back...', event.detail);
      toast('Database switched. Returning to purchase table.');
      leaveEdit();
    };

    window.addEventListener('apiUrlChanged', handleApiUrlChange);

    return () => {
      window.removeEventListener('apiUrlChanged', handleApiUrlChange);
    };
  }, [navigate]);

  useEffect(() => {
    setupPortalContainers();
    return teardownPortalContainers;
  }, []);

  useEffect(() => {
    const loadPurchaseData = async () => {
      if (hasFetchedPurchase.current) return;
      let resolvedId = purchaseId;

      // If no direct ID but purchaseNo is provided, or if resolvedId is a doc number string
      if (!resolvedId && purchaseNo) {
        resolvedId = purchaseNo;
      }

      if (resolvedId && !/^\d+$/.test(String(resolvedId).trim())) {
        try {
          const searchRes = await listOldMetalPurchases({
            search: String(resolvedId).trim(),
          });
          if (isOldMetalApiSuccess(searchRes)) {
            const rows = normalizeOldMetalListRows(searchRes);
            const match =
              rows.find(
                (r) =>
                  String(r.purchase_no || "").trim().toUpperCase() ===
                    String(resolvedId).trim().toUpperCase() ||
                  String(r.id || "").trim() === String(resolvedId).trim(),
              ) || rows[0];
            if (match?.id) resolvedId = match.id;
          }
        } catch (searchErr) {
          console.warn("Error resolving purchase by doc number:", searchErr);
        }
      }

      if (!resolvedId) {
        toast.error("Purchase ID not provided");
        leaveEdit();
        return;
      }

      hasFetchedPurchase.current = true;
      setIsLoading(true);
      try {
        let response = await showOldMetalPurchaseById({ id: resolvedId });
        if (!isOldMetalApiSuccess(response)) {
          // Fallback search in case resolvedId was different
          const candidate = purchaseNo || purchaseId;
          if (candidate && candidate !== resolvedId) {
            try {
              const searchRes = await listOldMetalPurchases({
                search: String(candidate).trim(),
              });
              if (isOldMetalApiSuccess(searchRes)) {
                const rows = normalizeOldMetalListRows(searchRes);
                const match =
                  rows.find(
                    (r) =>
                      String(r.purchase_no || "").trim().toUpperCase() ===
                        String(candidate).trim().toUpperCase() ||
                      String(r.id || "").trim() === String(candidate).trim(),
                  ) || rows[0];
                if (match?.id) {
                  resolvedId = match.id;
                  response = await showOldMetalPurchaseById({ id: resolvedId });
                }
              }
            } catch (err) {
              console.warn("Fallback search failed:", err);
            }
          }
        }

        if (!isOldMetalApiSuccess(response)) {
          toast.error(response?.message || "Failed to load purchase data");
          leaveEdit();
          return;
        }
        const doc = pickOldMetalShowDocument(response);
        const purchaseData = mapOldMetalShowToLegacyCached(doc);
        if (!purchaseData) {
          toast.error("Purchase data not found");
          leaveEdit();
          return;
        }

        // Extract purchase_details, purchase_items, and payments
        const purchaseDetails = purchaseData.purchase_details || {};
        const purchaseItems = purchaseData.purchase_items || [];
        const payments = purchaseData.payments || [];

        // Set date
        if (purchaseDetails.date) {
          setSelectedDate(purchaseDetails.date);
        } else if (purchaseDetails.bill_date) {
          setSelectedDate(purchaseDetails.bill_date);
        }

        // Set customer from payload directly
        if (purchaseDetails.user_id) {
          setSelectedCustomerId(purchaseDetails.user_id);
        }
        setCustomerMobile(purchaseDetails.user_mobile || "");
        setCustomerMobileSearchText(purchaseDetails.user_mobile || "");
        setCustomerName(purchaseDetails.user_name || "");
        setCustomerNameSearchText(purchaseDetails.user_name || "");
        setCustomerAddress(purchaseDetails.address || "");
        setCustomerArea(purchaseDetails.area || "");
        setCustomerCity(purchaseDetails.city || "");
        setCustomerState(purchaseDetails.state || "");

        // Set bill type and GST from payload directly
        if (purchaseDetails.bill_type !== undefined) {
          setBillType(String(purchaseDetails.bill_type));
        }
        setBillTypeSearchText(
          purchaseDetails.bill_type_name ||
          (purchaseDetails.bill_type !== undefined
            ? String(purchaseDetails.bill_type)
            : "")
        );
        if (purchaseDetails.bill_type_applicable !== undefined) {
          const applicable =
            purchaseDetails.bill_type_applicable === 1 ||
            purchaseDetails.bill_type_applicable === "1";
          if (applicable) {
            if (purchaseDetails.bill_type_gst !== undefined) {
              setGstPercentage(String(purchaseDetails.bill_type_gst));
            } else if (purchaseDetails.gst_percentage !== undefined) {
              setGstPercentage(String(purchaseDetails.gst_percentage));
            }
          } else {
            setGstPercentage("0");
          }
        } else if (purchaseDetails.gst_percentage !== undefined) {
          setGstPercentage(String(purchaseDetails.gst_percentage));
        }

        // Set items from purchase_items array
        if (purchaseItems.length > 0) {
          const mappedItems = purchaseItems.map((item, idx) => ({
            id: idx + 1,
            itemId: item.id || null,
            product_group_id: item.product_group_id
              ? String(item.product_group_id)
              : "",
            pcs: item.pcs ? String(item.pcs) : "",
            ct: item.ct ? String(item.ct) : "",
            gwt: item.gwt ? String(item.gwt) : "",
            lwt: item.lwt ? String(item.lwt) : "",
            nwt: item.nwt ? String(item.nwt) : "",
            touch: item.touch ? String(item.touch) : "",
            fine_wt: item.fine_wt ? String(item.fine_wt) : "",
            total_amt: item.total_amt ? String(item.total_amt) : "",
            // Preserve saved amounts on load; live-rate effect skips manual rows
            isTotalAmtManual: !!(item.total_amt || item.total_amount),
          }));
          setTableRows(mappedItems);
          const searchMap = {};
          purchaseItems.forEach((item, idx) => {
            searchMap[idx + 1] =
              item.product_group_name || item.item_name || "";
          });
          setProductGroupSearchText(searchMap);

          const uniquePgIds = [
            ...new Set(
              purchaseItems
                .map((item) => item.product_group_id)
                .filter((id) => id != null && id !== ""),
            ),
          ];
          const resolved = await Promise.all(
            uniquePgIds.map((id) => fetchProductGroupOptionById(id)),
          );
          const cacheItems = resolved.filter(Boolean);
          if (cacheItems.length) {
            setProductGroupOptionsCache((prev) =>
              mergeProductGroupOptions(prev, cacheItems),
            );
          }
        } else {
          // Keep at least one empty row
          setTableRows([
            {
              id: 1,
              itemId: null,
              product_group_id: "",
              pcs: "",
              ct: "",
              gwt: "",
              lwt: "",
              nwt: "",
              touch: "",
              fine_wt: "",
              total_amt: "",
              isTotalAmtManual: false,
            },
          ]);
        }

        if (payments.length > 0) {
          const mappedPayments = mapApiPaymentsToUiRows(payments);

          // If we have payments, use them; otherwise use default
          if (mappedPayments.length > 0) {
            setPaymentRows(mappedPayments);
          } else {
            setPaymentRows(createDefaultSettlementRows());
          }
        } else {
          setPaymentRows(createDefaultSettlementRows());
        }

        // Set round off if available (not in the response structure shown, but keeping for compatibility)
        if (purchaseDetails.round_off !== undefined) {
          setRoundOffAmount(String(purchaseDetails.round_off));
          setIsManualRoundOff(true);
        }
        if (purchaseDetails.notes != null) {
          setNote(purchaseDetails.notes || "");
        }
      } catch (error) {
        console.error("Error loading purchase data:", error);
        toast.error("Failed to load purchase data");
        leaveEdit();
      } finally {
        setIsLoading(false);
      }
    };

    if (purchaseId || purchaseNo) {
      loadPurchaseData();
    }
  }, [purchaseId, purchaseNo, navigate]);

  const getProductGroupRowOptions = (rowId) =>
    productGroupRowResults[rowId] || [];

  const applyPoolHeaderFromGroup = (group) => {
    if (!group) {
      setProductGroupPoolHeader(null);
      return;
    }
    setProductGroupPoolHeader({
      pcs: numPool(group.pool_pcs),
      nwt: numPool(group.pool_nwt),
    });
  };

  const syncPoolHeaderForRow = (rowId) => {
    const options = getProductGroupRowOptions(rowId);
    if (productGroupDropdownActive[rowId] && options.length > 0) {
      const idx = productGroupHighlightedIndex[rowId] || 0;
      applyPoolHeaderFromGroup(options[idx]);
      return;
    }
    const row = tableRows.find((r) => String(r.id) === String(rowId));
    if (row?.product_group_id) {
      const cached = productGroupOptionsCache.find(
        (o) => String(o.value) === String(row.product_group_id),
      );
      applyPoolHeaderFromGroup(cached);
      return;
    }
    setProductGroupPoolHeader(null);
  };

  const fetchProductGroupByPrefix = useCallback(async (rowId, prefix) => {
    const trimmed = String(prefix || "").trim();
    if (trimmed.length < 3) {
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: [] }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: false }));
      return;
    }

    if (lastSearchedProductGroupPrefixRef.current[rowId] === trimmed) {
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: true }));
      return;
    }

    setProductGroupSearchLoading((prev) => ({ ...prev, [rowId]: true }));
    try {
      const opts = await searchProductGroupSelectOptions(trimmed);
      lastSearchedProductGroupPrefixRef.current[rowId] = trimmed;
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: opts }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: true }));
      if (opts.length > 0) {
        applyPoolHeaderFromGroup(opts[0]);
      }
    } catch (e) {
      console.error("Error searching product groups:", e);
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: [] }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: true }));
    } finally {
      setProductGroupSearchLoading((prev) => ({ ...prev, [rowId]: false }));
    }
  }, []);

  const handleProductGroupChange = (rowId, value) => {
    setProductGroupSearchText((prev) => ({ ...prev, [rowId]: value }));
    setProductGroupHighlightedIndex((prev) => ({ ...prev, [rowId]: 0 }));

    if (productGroupSearchTimerRef.current[rowId]) {
      clearTimeout(productGroupSearchTimerRef.current[rowId]);
    }

    if (!value.trim()) {
      handleTableRowChange(rowId, "product_group_id", "");
      setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: [] }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: false }));
      lastSearchedProductGroupPrefixRef.current[rowId] = "";
      setProductGroupPoolHeader(null);
      return;
    }

    const hasMinChars = value.trim().length >= 3;
    setProductGroupDropdownActive((prev) => ({
      ...prev,
      [rowId]: hasMinChars,
    }));

    if (hasMinChars) {
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: false }));
      productGroupSearchTimerRef.current[rowId] = setTimeout(() => {
        fetchProductGroupByPrefix(rowId, value.trim());
      }, 300);
    } else {
      setProductGroupRowResults((prev) => ({ ...prev, [rowId]: [] }));
      setProductGroupApiCalled((prev) => ({ ...prev, [rowId]: false }));
      lastSearchedProductGroupPrefixRef.current[rowId] = "";
    }
  };

  const handleProductGroupSelect = (rowId, selectedGroup) => {
    handleTableRowChange(rowId, "product_group_id", String(selectedGroup.value));
    setProductGroupSearchText((prev) => ({
      ...prev,
      [rowId]: selectedGroup.name || selectedGroup.label || "",
    }));
    setProductGroupOptionsCache((prev) =>
      mergeProductGroupOptions(prev, [selectedGroup]),
    );
    applyPoolHeaderFromGroup(selectedGroup);
    setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));

    const nextInput = productGroupInputRefs.current[rowId]
      ?.closest("tr")
      ?.querySelector('input[placeholder="0"]');
    if (nextInput) nextInput.focus();
  };

  const handleProductGroupKeyDown = (e, rowId) => {
    const filtered = getProductGroupRowOptions(rowId);

    if (
      !productGroupDropdownActive[rowId] ||
      filtered.length === 0 ||
      productGroupSearchLoading[rowId]
    ) {
      if (e.key === "Enter" || e.key === "Tab") {
        const nextInput = e.target
          .closest("tr")
          ?.querySelector('input[placeholder="0"]');
        if (nextInput) nextInput.focus();
      }
      return;
    }

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setProductGroupHighlightedIndex((prev) => {
          const nextIdx = Math.min(
            (prev[rowId] || 0) + 1,
            filtered.length - 1,
          );
          applyPoolHeaderFromGroup(filtered[nextIdx]);
          return { ...prev, [rowId]: nextIdx };
        });
        break;
      case "ArrowUp":
        e.preventDefault();
        setProductGroupHighlightedIndex((prev) => {
          const nextIdx = Math.max((prev[rowId] || 0) - 1, 0);
          applyPoolHeaderFromGroup(filtered[nextIdx]);
          return { ...prev, [rowId]: nextIdx };
        });
        break;
      case "Enter":
        e.preventDefault();
        handleProductGroupSelect(
          rowId,
          filtered[productGroupHighlightedIndex[rowId] || 0],
        );
        break;
      case "Escape":
        setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
        break;
      case "Tab":
        setProductGroupDropdownActive((prev) => ({ ...prev, [rowId]: false }));
        break;
      default:
        break;
    }
  };

  const renderProductGroupDropdown = (rowId) => {
    if (!productGroupDropdownActive[rowId]) return null;

    const searchText = productGroupSearchText[rowId] || "";
    if (!searchText.trim() || searchText.trim().length < 3) return null;

    const filtered = getProductGroupRowOptions(rowId);
    const loading = productGroupSearchLoading[rowId];
    const apiCalled = productGroupApiCalled[rowId];

    const inputElement = productGroupInputRefs.current[rowId];
    if (!inputElement) return null;

    const inputRect = inputElement.getBoundingClientRect();
    if (!inputRect) return null;

    const inputWidth = inputElement.offsetWidth;
    const maxVisibleItems = 5;
    const scrollableHeight = maxVisibleItems * 40;

    return ReactDOM.createPortal(
      <div
        ref={(el) => (productGroupDropdownRefs.current[rowId] = el)}
        className="dropdown-menu show shadow-sm"
        style={{
          position: "fixed",
          top: `${inputRect.bottom}px`,
          left: `${inputRect.left}px`,
          width: `${Math.max(inputWidth, 200)}px`,
          minWidth: `${Math.max(inputWidth, 200)}px`,
          maxWidth: `${Math.max(inputWidth, 280)}px`,
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,.15)",
          borderRadius: "0.25rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
          fontSize: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        <div
          style={{
            maxHeight: `${scrollableHeight}px`,
            overflowY:
              !loading && filtered.length > maxVisibleItems ? "auto" : "hidden",
            overflowX: "hidden",
          }}
        >
          {loading ? (
            <div
              className="dropdown-item text-muted"
              style={{ cursor: "default", padding: "0.5rem 1rem" }}
            >
              Searching...
            </div>
          ) : filtered.length > 0 ? (
            filtered.map((group, idx) => (
              <div
                key={group.value}
                ref={(el) => {
                  if (!productGroupItemsRefs.current[rowId]) {
                    productGroupItemsRefs.current[rowId] = [];
                  }
                  productGroupItemsRefs.current[rowId][idx] = el;
                }}
                className="dropdown-item"
                style={{
                  cursor: "pointer",
                  padding: "0.5rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === (productGroupHighlightedIndex[rowId] || 0)
                      ? "var(--theme-primary)"
                      : "transparent",
                  color:
                    idx === (productGroupHighlightedIndex[rowId] || 0)
                      ? "#fff"
                      : "inherit",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                }}
                onMouseEnter={() => {
                  setProductGroupHighlightedIndex((prev) => ({
                    ...prev,
                    [rowId]: idx,
                  }));
                  applyPoolHeaderFromGroup(group);
                }}
                onMouseDown={() => handleProductGroupSelect(rowId, group)}
              >
                {productGroupOptionDisplayName(group)}
              </div>
            ))
          ) : apiCalled ? (
            <div
              className="dropdown-item text-muted"
              style={{ cursor: "default", padding: "0.5rem 1rem" }}
            >
              No matching items
            </div>
          ) : null}
        </div>
      </div>,
      document.getElementById("dropdown-portal") || document.body,
    );
  };

  // Removed bill types fetch; derive from payload in loadPurchaseData

  const applyBillTypeSelection = useCallback(
    (item) => {
      if (!item) return;
      setBillType(item.value);
      setBillTypeSearchText(item.label);
      if (item.applicable === "1" || item.applicable === 1) {
        setGstPercentage(item.gstPercentage);
      } else {
        setGstPercentage("0");
      }
    },
    [setGstPercentage]
  );

  useEffect(() => {
    if (!billTypes.length) return;

    const currentSelection = billTypes.find((item) => item.value === billType);

    if (currentSelection) {
      setBillTypeSearchText(currentSelection.label);
      if (
        currentSelection.applicable === "1" ||
        currentSelection.applicable === 1
      ) {
        setGstPercentage(currentSelection.gstPercentage);
      } else {
        setGstPercentage("0");
      }
      return;
    }
  }, [billTypes, billType]);

  useEffect(() => {
    if (!billTypes || billTypes.length === 0) return;

    const selectedBillType = billTypes.find(
      (item) =>
        item.label.toLowerCase() === billTypeSearchText.toLowerCase() ||
        item.value === billType
    );

    if (!selectedBillType) return;

    if (billType !== selectedBillType.value) {
      setBillType(selectedBillType.value);
    }

    if (
      selectedBillType.applicable === "1" ||
      selectedBillType.applicable === 1
    ) {
      if (gstPercentage !== selectedBillType.gstPercentage) {
        setGstPercentage(selectedBillType.gstPercentage);
      }
    } else if (gstPercentage !== "0") {
      setGstPercentage("0");
    }
  }, [billTypes, billTypeSearchText, billType, gstPercentage]);

  // Set today's date as default (only if not editing)
  useEffect(() => {
    if (!purchaseId) {
      const today = new Date().toISOString().split("T")[0];
      setSelectedDate(today);
    }
  }, [purchaseId]);

  // Removed customer users fetch; derive customer data from payload in loadPurchaseData

  // Fetch bank accounts
  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const response = await listBankAccounts();
        if (response?.success && Array.isArray(response.data?.bank_accounts)) {
          const fetchedBankDetails = response.data.bank_accounts.map((bank) => ({
            id: bank.id,
            bankName: bank.bank_name || "",
            accountHolder: bank.holder_name || "",
            accountType: bank.account_type || "",
            accountNumber: bank.account_number || "",
            ifscCode: bank.ifsc_code || "",
            branchName: bank.branch_name || "",
          }));
          setBankAccounts(fetchedBankDetails);
          setPaymentTypes(
            fetchedBankDetails.map((bank) => ({
              value: bank.id,
              label: bank.bankName || bank.accountNumber || `Bank ${bank.id}`,
            })),
          );
        } else {
          setBankAccounts([]);
          setPaymentTypes([]);
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
        setBankAccounts([]);
        setPaymentTypes([]);
      }
    };
    fetchBankDetails();
  }, []);

  const getRowMetalFlags = (row) => {
    const pg = productGroupOptionsCache.find(
      (o) => String(o.value) === String(row.product_group_id),
    );
    const metal = String(
      pg?.metal || pg?.name || pg?.label || "",
    ).toUpperCase();
    return {
      isGold: metal.includes("GOLD"),
      isSilver: metal.includes("SILVER"),
    };
  };

  const calculateFineWt = (nwt, touch) => {
    const nwtVal = parseNumericValue(nwt);
    const touchVal = parseNumericValue(touch);

    if (nwtVal > 0 && touchVal > 0) {
      return (nwtVal * (touchVal / 100)).toFixed(3);
    }
    return "0.000";
  };

  // Calculate total amount based on ct (carat) and fine_wt
  // If ct is provided:
  //   Gold: total_amt = (ct/24) * live_gold_rate_per_gram * fine_wt
  //   Silver: total_amt = (ct/999) * live_silver_rate_per_gram * fine_wt
  // If ct is not provided, use touch: total_amt = (touch/100) * fine_wt * rate_per_gram
  // Note: when showLiveRate is ON, master rates are per 10g (gold) / 1000g (silver).
  // When showLiveRate is OFF, master rates are already per gram.
  const calculateTotalAmount = (row) => {
    const fineWt = parseNumericValue(row.fine_wt);
    const ct = parseNumericValue(row.ct);
    const touch = parseNumericValue(row.touch);

    // Need fine_wt for calculation
    if (!fineWt || fineWt === 0) {
      return "0.00";
    }

    // Determine metal type from selected product group
    const { isGold, isSilver } = getRowMetalFlags(row);

    // Get rate per gram depending on whether live-rate is enabled.
    // When live rate is enabled, master rates are per 10g (gold) / 1000g (silver).
    // When live rate is disabled, master rates are already per gram.
    const goldRatePerGram = showLiveRate
      ? masterGoldRate / 10
      : masterGoldRate;
    const silverRatePerGram = showLiveRate
      ? masterSilverRate / 1000
      : masterSilverRate;
    const liveRatePerGram = isGold ? goldRatePerGram : isSilver ? silverRatePerGram : 0;

    if (liveRatePerGram === 0) {
      return "0.00";
    }

    let total = 0;

    // If ct (carat) is provided, use purity-based calculation
    if (ct && ct > 0) {
      if (isGold) {
        // Gold: (ct/24) * live_rate_per_gram * fine_wt
        const purityRate = (ct / 24) * liveRatePerGram;
        total = purityRate * fineWt;
      } else if (isSilver) {
        // Silver: (ct/999) * live_rate_per_gram * fine_wt
        const purityRate = (ct / 999) * liveRatePerGram;
        total = purityRate * fineWt;
      }
    } else if (touch && touch > 0) {
      // If ct is not provided, use touch formula: (touch/100) * fine_wt * rate_per_gram
      total = (touch / 100) * fineWt * liveRatePerGram;
    }

    return total.toFixed(2);
  };

  // When live rates change (e.g. "live price" checkbox toggled), update totals
  // for rows that were not manually overridden.
  useEffect(() => {
    setTableRows((prev) =>
      prev.map((row) => {
        if (row.isTotalAmtManual) return row;
        const nextTotal = calculateTotalAmount(row);
        // Avoid unnecessary state churn when nothing changes
        if (String(row.total_amt ?? "") === String(nextTotal ?? "")) {
          return row;
        }
        return { ...row, total_amt: nextTotal };
      }),
    );
  }, [masterGoldRate, masterSilverRate, showLiveRate, productGroupOptionsCache]);

  // Update fine_wt when nwt or touch changes
  // Update total_amt when fine_wt, touch, ct, or product_group_id changes (only if not manually edited)
  // Auto-calculate NWT: if GWT is entered, set NWT = GWT; if LWT is entered, set NWT = GWT - LWT
  const handleTableRowChange = (id, field, value) => {
    setTableRows((prev) =>
      prev.map((row) => {
        if (row.id === id) {
          const updatedRow = { ...row, [field]: value };

          // Auto-calculate NWT based on GWT and LWT
          if (field === "gwt") {
            // When GWT is entered, set NWT = GWT
            const gwtVal = parseNumericValue(value);
            updatedRow.nwt = gwtVal > 0 ? gwtVal.toFixed(3) : "";
          } else if (field === "lwt") {
            // When LWT is entered, calculate NWT = GWT - LWT
            const gwtVal = parseNumericValue(updatedRow.gwt);
            const lwtVal = parseNumericValue(value);
            if (gwtVal > 0) {
              const nwtVal = gwtVal - lwtVal;
              updatedRow.nwt = nwtVal > 0 ? nwtVal.toFixed(3) : "0.000";
            }
          }

          // Auto-calculate fine_wt when nwt or touch changes
          if (
            field === "nwt" ||
            field === "touch" ||
            field === "gwt" ||
            field === "lwt"
          ) {
            updatedRow.fine_wt = calculateFineWt(
              updatedRow.nwt,
              updatedRow.touch
            );
          }

          // If total_amt is manually changed, mark it as manual and don't recalculate
          if (field === "total_amt") {
            updatedRow.isTotalAmtManual = true;
          } else {
            // If weights/fields change, reset manual flag and recalculate total_amt
            if (
              field === "fine_wt" ||
              field === "touch" ||
              field === "ct" ||
              field === "product_group_id" ||
              field === "nwt" ||
              field === "gwt" ||
              field === "lwt"
            ) {
              updatedRow.isTotalAmtManual = false;
              updatedRow.total_amt = calculateTotalAmount(updatedRow);
            }
          }

          return updatedRow;
        }
        return row;
      })
    );
  };

  const handleAddTableRow = () => {
    const safeTableRows = Array.isArray(tableRows) ? tableRows : [];
    const newId = Math.max(...safeTableRows.map((r) => r.id), 0) + 1;
    setTableRows([
      ...safeTableRows,
      {
        id: newId,
        itemId: null, // New item, no database ID
        product_group_id: "",
        pcs: "",
        ct: "",
        gwt: "",
        lwt: "",
        nwt: "",
        touch: "",
        fine_wt: "",
        total_amt: "",
        isTotalAmtManual: false,
      },
    ]);
    setTimeout(() => {
      if (tableContainerRef.current) {
        tableContainerRef.current.scrollTop =
          tableContainerRef.current.scrollHeight;
      }
    }, 150);
  };

  // Handle total_amt focus - add new row when focused
  const handleTotalAmtFocus = (rowId) => {
    // Check if this is the last row
    const isLastRow = rowId === tableRows[tableRows.length - 1].id;
    if (isLastRow) {
      // Add a new row
      handleAddTableRow();
    }
  };

  const handleRemoveTableRow = (id) => {
    if (tableRows.length > 1) {
      setTableRows((prev) => prev.filter((row) => row.id !== id));
    }
  };

  // Customer selection handlers (like Sales.jsx)
  const handleCustomerMobileChange = (e) => {
    const value = sanitizeMobileInput(e.target.value);
    setCustomerMobileSearchText(value);
    setCustomerMobile(value);
    setCustomerMobileDropdownActive(true);
    setCustomerMobileHighlightedIndex(0);
    setSelectedCustomerId(null);
  };

  const getFilteredUserssByMobile = (searchText) => {
    if (!searchText) return userss;
    const searchLower = searchText.toLowerCase();
    return userss.filter((item) =>
      item.mobile.toLowerCase().includes(searchLower)
    );
  };

  const handleCustomerMobileSelect = (selectedItem) => {
    setCustomerMobile(selectedItem.mobile);
    setCustomerMobileSearchText(selectedItem.mobile);
    setCustomerMobileDropdownActive(false);
    setSelectedCustomerId(selectedItem.id);
    setCustomerName(selectedItem.fullName);
    setCustomerNameSearchText(selectedItem.fullName);
    setCustomerState(selectedItem.state || "");
    setCustomerAddress(selectedItem.address || "");
    setCustomerArea(selectedItem.area || "");
    setCustomerCity(selectedItem.city || "");
    setCustomerSaleBalance(
      selectedItem.saleBalance ?? selectedItem.sale_balance ?? "",
    );
  };

  const handleCustomerMobileKeyDown = (e) => {
    const filtered = getFilteredUserssByMobile(customerMobileSearchText);

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setCustomerMobileHighlightedIndex((prevIndex) => {
          const newIndex =
            prevIndex < filtered.length - 1 ? prevIndex + 1 : prevIndex;
          if (customerMobileItemsRef.current[newIndex]) {
            customerMobileItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "ArrowUp":
        e.preventDefault();
        setCustomerMobileHighlightedIndex((prevIndex) => {
          const newIndex = prevIndex > 0 ? prevIndex - 1 : 0;
          if (customerMobileItemsRef.current[newIndex]) {
            customerMobileItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "Enter":
        e.preventDefault();
        if (filtered.length > 0 && customerMobileDropdownActive) {
          handleCustomerMobileSelect(filtered[customerMobileHighlightedIndex]);
        }
        break;
      case "Escape":
        e.preventDefault();
        setCustomerMobileDropdownActive(false);
        break;
      case "Tab":
        setCustomerMobileDropdownActive(false);
        break;
      default:
        break;
    }
  };

  // Handle bill type input change
  const handleBillTypeChange = (e) => {
    setBillTypeSearchText(e.target.value);
    setBillTypeDropdownActive(true);
    setBillTypeHighlightedIndex(0);
  };

  // Filter the bill types based on search input
  const getFilteredBillTypes = (searchText) => {
    if (!searchText) return billTypes;
    const searchLower = searchText.toLowerCase();
    return billTypes.filter((item) =>
      item.label.toLowerCase().includes(searchLower)
    );
  };

  // Handle selection of a bill type
  const handleBillTypeSelect = (selectedItem) => {
    applyBillTypeSelection(selectedItem);
    setBillTypeDropdownActive(false);
  };

  // Handle key navigation in bill type dropdown
  const handleBillTypeKeyDown = (e) => {
    const filtered = getFilteredBillTypes(billTypeSearchText);

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setBillTypeHighlightedIndex((prevIndex) => {
          const newIndex =
            prevIndex < filtered.length - 1 ? prevIndex + 1 : prevIndex;
          if (billTypeItemsRef.current[newIndex]) {
            billTypeItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "ArrowUp":
        e.preventDefault();
        setBillTypeHighlightedIndex((prevIndex) => {
          const newIndex = prevIndex > 0 ? prevIndex - 1 : 0;
          if (billTypeItemsRef.current[newIndex]) {
            billTypeItemsRef.current[newIndex].scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
          }
          return newIndex;
        });
        break;
      case "Enter":
        e.preventDefault();
        if (filtered.length > 0 && billTypeDropdownActive) {
          handleBillTypeSelect(filtered[billTypeHighlightedIndex]);
        }
        break;
      case "Escape":
        e.preventDefault();
        setBillTypeDropdownActive(false);
        break;
      case "Tab":
        setBillTypeDropdownActive(false);
        break;
      default:
        break;
    }
  };

  const renderBillTypeDropdown = () => {
    if (!billTypeDropdownActive) return null;

    const filtered = getFilteredBillTypes(billTypeSearchText);
    billTypeItemsRef.current = [];

    const inputRect = billTypeInputRef.current
      ? billTypeInputRef.current.getBoundingClientRect()
      : null;

    if (!inputRect) return null;

    const scrollY = window.scrollY || window.pageYOffset;
    const scrollX = window.scrollX || window.pageXOffset;

    const top = inputRect.top + inputRect.height + scrollY - 1;
    const left = inputRect.left + scrollX;

    return ReactDOM.createPortal(
      <div
        ref={billTypeDropdownRef}
        className="dropdown-menu show shadow-sm"
        style={{
          position: "fixed",
          top: `${top}px`,
          left: `${left}px`,
          width: `${inputRect.width}px`,
          minWidth: `${inputRect.width}px`,
          maxWidth: `${inputRect.width}px`,
          maxHeight: "150px",
          overflowY: "auto",
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,.15)",
          borderRadius: "0.25rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
          fontSize: "12px",
          lineHeight: "1.2",
        }}
      >
        {filtered.length > 0 ? (
          filtered.map((item, idx) => {
            const isSelected =
              item.label.toLowerCase() === billTypeSearchText.toLowerCase();

            return (
              <div
                key={idx}
                ref={(el) => (billTypeItemsRef.current[idx] = el)}
                className={`dropdown-item ${idx === billTypeHighlightedIndex ? "active" : ""
                  }`}
                style={{
                  cursor: "pointer",
                  padding: "0.25rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === billTypeHighlightedIndex
                      ? "var(--theme-primary)"
                      : isSelected
                        ? "#f0f0f0"
                        : "transparent",
                  color: idx === billTypeHighlightedIndex ? "#fff" : "inherit",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={() => setBillTypeHighlightedIndex(idx)}
                onMouseDown={() => handleBillTypeSelect(item)}
              >
                {item.label}
              </div>
            );
          })
        ) : (
          <div className="dropdown-item disabled">No matching bill types</div>
        )}
      </div>,
      document.getElementById("dropdown-portal") || document.body
    );
  };

  useEffect(() => {
    function handleClickOutside(event) {
      // Handle bill type dropdown
      if (
        billTypeDropdownRef.current &&
        !billTypeDropdownRef.current.contains(event.target) &&
        billTypeInputRef.current &&
        !billTypeInputRef.current.contains(event.target)
      ) {
        setBillTypeDropdownActive(false);
      }

      // Handle customer mobile dropdown
      if (
        customerMobileDropdownRef.current &&
        !customerMobileDropdownRef.current.contains(event.target) &&
        customerMobileInputRef.current &&
        !customerMobileInputRef.current.contains(event.target)
      ) {
        setCustomerMobileDropdownActive(false);
      }

      Object.keys(productGroupDropdownActive).forEach((rowId) => {
        if (productGroupDropdownActive[rowId]) {
          const dropdownRef = productGroupDropdownRefs.current[rowId];
          const inputRef = productGroupInputRefs.current[rowId];
          if (
            dropdownRef &&
            !dropdownRef.contains(event.target) &&
            inputRef &&
            !inputRef.contains(event.target)
          ) {
            setProductGroupDropdownActive((prev) => ({
              ...prev,
              [rowId]: false,
            }));
          }
        }
      });
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [productGroupDropdownActive]);

  const renderCustomerMobileDropdown = () => {
    if (!customerMobileDropdownActive) return null;

    const filtered = getFilteredUserssByMobile(customerMobileSearchText);
    customerMobileItemsRef.current = [];

    const inputWidth = customerMobileInputRef.current
      ? customerMobileInputRef.current.offsetWidth
      : 150;
    const inputRect = customerMobileInputRef.current
      ? customerMobileInputRef.current.getBoundingClientRect()
      : null;

    if (!inputRect) return null;

    return ReactDOM.createPortal(
      <div
        ref={customerMobileDropdownRef}
        className="dropdown-menu show shadow-sm"
        style={{
          position: "fixed",
          top: `${inputRect.bottom}px`,
          left: `${inputRect.left}px`,
          width: `${inputWidth}px`,
          minWidth: `${inputWidth}px`,
          maxWidth: `${inputWidth}px`,
          maxHeight: "150px",
          overflowY: "auto",
          zIndex: 9999,
          border: "1px solid rgba(0,0,0,.15)",
          borderRadius: "0.25rem",
          padding: "0.5rem 0",
          backgroundColor: "#fff",
          fontSize: "12px",
          lineHeight: "1.2",
        }}
      >
        {filtered.length > 0 ? (
          filtered.map((item, idx) => {
            const isSelected =
              item.mobile.toLowerCase() ===
              customerMobileSearchText.toLowerCase();

            return (
              <div
                key={idx}
                ref={(el) => (customerMobileItemsRef.current[idx] = el)}
                className={`dropdown-item ${idx === customerMobileHighlightedIndex ? "active" : ""
                  }`}
                style={{
                  cursor: "pointer",
                  padding: "0.25rem 1rem",
                  fontSize: "0.85rem",
                  backgroundColor:
                    idx === customerMobileHighlightedIndex
                      ? "var(--theme-primary)"
                      : isSelected
                        ? "#f0f0f0"
                        : "transparent",
                  color:
                    idx === customerMobileHighlightedIndex ? "#fff" : "inherit",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  transition: "background-color 0.2s, color 0.2s",
                }}
                onMouseEnter={() => setCustomerMobileHighlightedIndex(idx)}
                onMouseDown={() => handleCustomerMobileSelect(item)}
              >
                {item.mobile} - {item.name}
              </div>
            );
          })
        ) : (
          <div className="dropdown-item disabled">No matching users</div>
        )}
      </div>,
      document.getElementById("dropdown-portal") || document.body
    );
  };

  // Calculate totals
  const totalAmount = useMemo(() => {
    return tableRows.reduce(
      (sum, row) => sum + parseNumericValue(row.total_amt),
      0
    );
  }, [tableRows]);

  const settlementTotal = useMemo(() => {
    return (Array.isArray(paymentRows) ? paymentRows : []).reduce(
      (sum, row) => sum + parseNumericValue(row.amount),
      0
    );
  }, [paymentRows]);

  const payablePaidTotal = useMemo(() => {
    return (Array.isArray(payableRows) ? payableRows : []).reduce(
      (sum, row) => sum + parseNumericValue(row.amount),
      0
    );
  }, [payableRows]);

  // Calculate GST amount based on percentage
  const calculateGstAmount = () => {
    if (!gstPercentage || isNaN(gstPercentage)) {
      return {
        total: 0,
        sgst: 0,
        cgst: 0,
        igst: 0,
      };
    }

    const gstRate = parseFloat(gstPercentage);
    const totalGstAmount = (totalAmount * gstRate) / 100;

    // Get the business state (you may need to replace this with your actual business state)
    const businessState = "Gujarat"; // Replace with your actual business state

    // Check if customer state matches business state (case-insensitive comparison)
    const isIntraStateTransaction =
      customerState &&
      customerState.toLowerCase() === businessState.toLowerCase();

    if (isIntraStateTransaction) {
      // For intra-state transactions, split GST into SGST and CGST
      const halfGstRate = gstRate / 2;
      const sgstAmount = (totalAmount * halfGstRate) / 100;
      const cgstAmount = (totalAmount * halfGstRate) / 100;

      return {
        total: totalGstAmount,
        sgst: sgstAmount,
        cgst: cgstAmount,
        igst: 0,
      };
    } else {
      // For inter-state transactions, apply full GST as IGST
      return {
        total: totalGstAmount,
        sgst: 0,
        cgst: 0,
        igst: totalGstAmount,
      };
    }
  };

  const amountBeforeRoundOff = totalAmount - calculateGstAmount().total;
  const getAutoPaymentRoundOff = () =>
    autoRoundOff(amountBeforeRoundOff).roundOff;
  const getEffectiveRoundOff = () => {
    if (isManualRoundOff) {
      return parseFloat(roundOffAmount) || 0;
    }
    return getAutoPaymentRoundOff();
  };
  const getDisplayRoundOff = () => {
    if (isManualRoundOff) {
      return roundOffAmount;
    }
    return getAutoPaymentRoundOff().toFixed(2);
  };

  const roundOff = getEffectiveRoundOff();
  const grandTotalValue = Math.max(0, amountBeforeRoundOff + roundOff);
  const totalPaidValue = settlementTotal;
  const payableAmountValue = Math.max(0, totalPaidValue - grandTotalValue);
  const remainingAmount =
    totalPaidValue > grandTotalValue
      ? Math.max(0, payableAmountValue - payablePaidTotal)
      : Math.max(0, grandTotalValue - totalPaidValue);

  // Handle round-off amount change (any edit locks manual mode)
  const handleRoundOffChange = (e) => {
    handleRoundOffInputChange(
      e,
      (value) => {
        setIsManualRoundOff(true);
        setRoundOffAmount(value);
      },
      {
        allowNegative: true,
        simple: true,
      },
    );
  };

  const handleSave = async () => {
    const itemErrors = collectOldMetalFieldErrors(tableRows);
    const hasItemErrors = Object.keys(itemErrors).length > 0;
    setItemFieldErrors(hasItemErrors ? itemErrors : {});

    if (!selectedDate) {
      toast.error("Please select a date");
      return;
    }

    if (!selectedCustomerId) {
      toast.error("Please select a customer");
      return;
    }

    // Validate table rows
    const validRows = tableRows.filter(
      (row) =>
        row.product_group_id &&
        (parseNumericValue(row.gwt) > 0 || parseNumericValue(row.pcs) > 0),
    );
    if (hasItemErrors || validRows.length === 0) {
      return;
    }

    setIsSaving(true);

    try {
      const totalAmt = validRows.reduce(
        (sum, row) => sum + parseNumericValue(row.total_amt),
        0,
      );

      const gstAmts = calculateGstAmount();
      const roundOffNum = getEffectiveRoundOff();
      const grandTotalNum = Math.max(
        0,
        Number((totalAmt - gstAmts.total + roundOffNum).toFixed(2)),
      );

      const paymentPersistKeys = [];
      const purchasePayments = buildStandardPaymentLines(paymentRows, {
        isUpdate: true,
        paymentTypes,
        payModeLabels: PAYMENT_METHOD_LABELS,
        createKey: createOldMetalIdempotencyKey,
        persistKeys: paymentPersistKeys,
      });

      if (paymentPersistKeys.length > 0) {
        setPaymentRows((prev) => {
          const next = [...prev];
          paymentPersistKeys.forEach(({ rowId, key }) => {
            const idx = next.findIndex((r) => r.id === rowId);
            if (idx >= 0) {
              next[idx] = { ...next[idx], paymentIdempotencyKey: key };
            }
          });
          return next;
        });
      }

      const itemsPayload = validRows.map((row) => {
        const itemId =
          row.itemId && row.itemId > 0 ? parseInt(row.itemId, 10) : null;
        const base = {
          product_group_id: Number(row.product_group_id),
          pcs: parseNumericValue(row.pcs),
          ct: parseNumericValue(row.ct),
          gwt: parseNumericValue(row.gwt),
          lwt: parseNumericValue(row.lwt),
          nwt: parseNumericValue(row.nwt),
          touch: parseNumericValue(row.touch),
          fine_wt: parseNumericValue(row.fine_wt),
          total_amount: parseNumericValue(row.total_amt),
          image: null,
        };
        return itemId ? { id: itemId, ...base } : base;
      });

      if (grandTotalNum <= 0) {
        toast.error("Grand total must be greater than zero");
        setIsSaving(false);
        return;
      }

      const baseBody = {
        id: Number(purchaseId),
        branch_id: getSessionBranchId(),
        customer_id: Number(selectedCustomerId),
        date: selectedDate,
        discount: 0,
        tax_amount: Number(gstAmts.total.toFixed(2)) || 0,
        round_off: roundOffNum,
        grand_total: grandTotalNum,
        notes: note?.trim() || null,
        items: itemsPayload,
        payments: purchasePayments,
      };

      const fingerprint = JSON.stringify(baseBody);
      if (
        !oldMetalUpdateIdempotencyKeyRef.current ||
        oldMetalUpdateFingerprintRef.current !== fingerprint
      ) {
        oldMetalUpdateIdempotencyKeyRef.current =
          createOldMetalIdempotencyKey();
        oldMetalUpdateFingerprintRef.current = fingerprint;
      }

      const response = await editOldMetalPurchase({
        idempotency_key: oldMetalUpdateIdempotencyKeyRef.current,
        ...baseBody,
      });

      if (isOldMetalApiSuccess(response)) {
        oldMetalUpdateIdempotencyKeyRef.current = null;
        oldMetalUpdateFingerprintRef.current = null;
        toast.success("Old Purchase updated successfully!");
        leaveEdit();
      } else {
        toast.error(response?.message || "Failed to update Old Purchase");
      }
    } catch (error) {
      console.error("Error updating Old Purchase:", error);
      const status = error?.response?.status;
      if (status === 403) toast.error("No permission");
      else
        toast.error(
          error?.response?.data?.message ||
          error.message ||
          "Failed to update Old Purchase",
        );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={isEmbedded ? cardClass : `body-wrapper ${cardClass}`}>
      <div className={isEmbedded ? "" : "container-fluid"}>
        <div className={`card shadow-sm ${cardClass} ${isEmbedded ? "border-0 mb-0" : ""}`}>
          <div
            className={`border-bottom ${isEmbedded ? "px-3 py-2" : "px-4 py-3"}`}
          >
            <div
              className={`d-flex align-items-center flex-wrap w-100 ${isEmbedded ? "gap-3" : "gap-5"}`}
            >
              <h4 className={`card-title mb-0 ${isEmbedded ? "fs-5" : ""}`}>
                {isViewOnly ? "View Old Purchase" : "Edit Old Purchase"}
              </h4>

              {/* Date Component */}
              <div className="col-lg-2 col-md-4 col-sm-6">
                <div className="d-flex align-items-center">
                  <label
                    className="form-label me-2 mb-0"
                    style={{
                      width: "50px",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                    }}
                  >
                    Date:
                  </label>
                  <input
                    type="date"
                    className={`form-control form-control-sm ${buttonClass}`}
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    style={{ fontSize: "0.85rem" }}
                  />
                </div>
              </div>

              {(productGroupPoolHeader ||
                customerSaleBalance !== "" ||
                isEmbedded) && (
                <div className="d-flex align-items-center flex-nowrap gap-2 ms-auto">
                  {customerSaleBalance !== "" && (
                    <span
                      className={`badge ${
                        parseFloat(customerSaleBalance) > 0
                          ? "bg-danger-subtle text-danger"
                          : "bg-success-subtle text-success"
                      }`}
                      style={{ fontSize: "0.85rem" }}
                    >
                      Pending: ₹
                      {parseFloat(customerSaleBalance || 0).toFixed(2)}
                    </span>
                  )}
                  <ProductGroupPoolBalance
                    balance={productGroupPoolHeader}
                    className=""
                  />
                  {isEmbedded && (
                    <button
                      type="button"
                      className="btn-close flex-shrink-0"
                      aria-label="Close"
                      onClick={() => onClose()}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="row mb-1">

              {/* Customer Mobile */}
              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                <div className="d-flex align-items-center">
                  <label
                    className="form-label me-2 mb-0"
                    style={{
                      width: "80px",
                      fontSize: "0.85rem",
                      fontWeight: "600",
                    }}
                  >
                    Customer:
                  </label>
                  <div className="position-relative flex-grow-1">
                    <input
                      ref={customerMobileInputRef}
                      type="text"
                      readOnly
                      value={customerMobileSearchText}
                      onChange={handleCustomerMobileChange}
                      onKeyDown={handleCustomerMobileKeyDown}
                      onClick={() => setCustomerMobileDropdownActive(true)}
                      className={`form-control form-control-sm ${buttonClass}`}
                      style={{
                        fontSize: "0.85rem",
                        backgroundColor: "transparent",
                        transition: "background-color 0.2s",
                      }}
                      onFocus={() => {
                        const inputElement = customerMobileInputRef.current;
                        if (inputElement) {
                          inputElement.style.backgroundColor = "#fff";
                        }
                        setCustomerMobileDropdownActive(true);
                      }}
                      onBlur={(e) => {
                        e.target.style.backgroundColor = "transparent";
                      }}
                      autoComplete="off"
                      placeholder="Mobile No"
                    />
                    {renderCustomerMobileDropdown()}
                  </div>
                </div>
              </div>

              {/* Customer Name */}
              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                <div className="d-flex align-items-center">
                  <div className="position-relative flex-grow-1">
                    <input
                      ref={customerNameInputRef}
                      type="text"
                      value={customerNameSearchText}
                      onChange={(e) => {
                        setCustomerNameSearchText(e.target.value);
                      }}
                      className={`form-control form-control-sm ${buttonClass}`}
                      style={{
                        fontSize: "0.85rem",
                        backgroundColor: "transparent",
                        transition: "background-color 0.2s",
                      }}
                      onFocus={() => {
                        const inputElement = customerNameInputRef.current;
                        if (inputElement) {
                          inputElement.style.backgroundColor = "#fff";
                        }
                      }}
                      onBlur={(e) => {
                        e.target.style.backgroundColor = "transparent";
                      }}
                      autoComplete="off"
                      placeholder="Name"
                      readOnly
                    />
                  </div>
                </div>
              </div>


              {/* userss Details Modal */}

              {/* userss Address */}
              <div className="col-lg-2 col-md-3 col-sm-6 mb-2">
                <input
                  type="text"
                  readOnly
                  value={customerAddress}
                  className={`form-control form-control-sm ${buttonClass}`}
                  style={{
                    fontSize: "0.85rem",
                    backgroundColor: "transparent",
                    transition: "background-color 0.2s",
                  }}
                  placeholder="Address"
                />
              </div>

              {/* Customer Area */}
              <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                <input
                  type="text"
                  readOnly
                  value={customerArea}
                  className={`form-control form-control-sm ${buttonClass}`}
                  style={{
                    fontSize: "0.85rem",
                    backgroundColor: "transparent",
                    transition: "background-color 0.2s",
                  }}
                  placeholder="Area"
                />
              </div>

              {/* City and Save Button Container - Adjust city visibility based on isNewuserss */}
              <div className="col-lg-2 col-md-3 col-sm-5 mb-2">
                <div className="d-flex align-items-center">
                  {/* Save Button */}
                </div>
              </div>

            </div>

            <div
              ref={tableContainerRef}
              className={`table-responsive border ${buttonTableStyle === "square" ? "rounded-0" : "rounded-2"
                } mt-3 ${cardClass}`}
              style={{
                maxHeight:
                  tableRows.length > 6
                    ? `${40 + 6 * 38 + 38}px`
                    : undefined,
                overflowY: tableRows.length > 6 ? "auto" : "visible",
              }}
            >
              {/* No table-rounded — overflow:hidden breaks sticky header/total */}
              <table className="table table-bordered table-hover table-sm mb-0 theme-header-table">
                <thead>
                  <tr>
                    {[
                      { label: "No.", width: "40px" },
                      { label: "Product Group", width: "150px" },
                      { label: "Pcs", width: "80px" },
                      { label: "Ct", width: "80px" },
                      { label: "G.Wt", width: "100px" },
                      { label: "L.Wt", width: "100px" },
                      { label: "N.Wt", width: "100px" },
                      { label: "Touch", width: "100px" },
                      { label: "Fine Wt", width: "100px" },
                      { label: "Total Amt", width: "120px" },
                    ].map((col) => (
                      <th
                        key={col.label}
                        className="px-2 py-2 text-center"
                        style={{
                          fontSize: "0.85rem",
                          width: col.width,
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                          position:
                            tableRows.length > 6 ? "sticky" : undefined,
                          top: tableRows.length > 6 ? 0 : undefined,
                          zIndex: tableRows.length > 6 ? 5 : undefined,
                        }}
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableRows.map((row, rowIndex) => (
                    <tr key={row.id} style={{ backgroundColor: "#ffffff" }}>
                      <td className="p-0" style={{ width: "40px" }}>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ height: "38px" }}
                        >
                          <span
                            style={{
                              fontSize: "0.85rem",
                              cursor: "pointer",
                              transition: "opacity 0.2s",
                            }}
                            onClick={() => handleRemoveTableRow(row.id)}
                            onMouseEnter={(e) => {
                              e.target.textContent = "×";
                              e.target.style.fontWeight = "600";
                            }}
                            onMouseLeave={(e) => {
                              e.target.textContent = rowIndex + 1;
                              e.target.style.fontWeight = "normal";
                            }}
                          >
                            {rowIndex + 1}
                          </span>
                        </div>
                      </td>
                      <td
                        className="p-0 position-relative"
                        style={{
                          width: "150px",
                          maxWidth: "150px",
                          ...lineCellErrorStyle(
                            itemFieldErrors[row.id]?.includes("product_group"),
                          ),
                        }}
                      >
                        <input
                          ref={(el) =>
                            (productGroupInputRefs.current[row.id] = el)
                          }
                          type="text"
                          value={productGroupSearchText[row.id] ?? ""}
                          onChange={(e) =>
                            handleProductGroupChange(row.id, e.target.value)
                          }
                          onKeyDown={(e) => handleProductGroupKeyDown(e, row.id)}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#fff";
                            const searchVal = productGroupSearchText[row.id] || "";
                            if (searchVal.trim().length >= 3) {
                              setProductGroupDropdownActive((prev) => ({
                                ...prev,
                                [row.id]: true,
                              }));
                            }
                            syncPoolHeaderForRow(row.id);
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            setTimeout(() => {
                              setProductGroupDropdownActive((prev) => ({
                                ...prev,
                                [row.id]: false,
                              }));
                            }, 200);
                          }}
                          className="form-control border-0 rounded-0"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            backgroundColor: "transparent",
                            width: "100%",
                            transition: "background-color 0.2s",
                          }}
                          autoComplete="off"
                          placeholder="Search..."
                        />
                        {renderProductGroupDropdown(row.id)}
                      </td>
                      <td
                        className="p-0"
                        style={{
                          width: "80px",
                          ...lineCellErrorStyle(
                            itemFieldErrors[row.id]?.includes("pcs"),
                          ),
                        }}
                      >
                        <input
                          type="text"
                          value={row.pcs}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleTableRowChange(row.id, "pcs", value);
                            }
                          }}
                          className="form-control border-0 rounded-0 text-end"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            backgroundColor: "transparent",
                            width: "100%",
                            transition: "background-color 0.2s",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#fff";
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                          autoComplete="off"
                          placeholder="0"
                        />
                      </td>
                      <td className="p-0" style={{ width: "80px" }}>
                        <input
                          type="text"
                          value={row.ct}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleTableRowChange(row.id, "ct", value);
                            }
                          }}
                          className="form-control border-0 rounded-0 text-end"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            backgroundColor: "transparent",
                            width: "100%",
                            transition: "background-color 0.2s",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#fff";
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                          autoComplete="off"
                          placeholder="0.00"
                        />
                      </td>
                      <td
                        className="p-0"
                        style={{
                          width: "100px",
                          ...lineCellErrorStyle(
                            itemFieldErrors[row.id]?.includes("gwt"),
                          ),
                        }}
                      >
                        <input
                          type="text"
                          value={row.gwt}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleTableRowChange(row.id, "gwt", value);
                            }
                          }}
                          className="form-control border-0 rounded-0 text-end"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            backgroundColor: "transparent",
                            width: "100%",
                            transition: "background-color 0.2s",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#fff";
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                          autoComplete="off"
                          placeholder="0.000"
                        />
                      </td>
                      <td className="p-0" style={{ width: "100px" }}>
                        <input
                          type="text"
                          value={row.lwt}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleTableRowChange(row.id, "lwt", value);
                            }
                          }}
                          className="form-control border-0 rounded-0 text-end"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            backgroundColor: "transparent",
                            width: "100%",
                            transition: "background-color 0.2s",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#fff";
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                          autoComplete="off"
                          placeholder="0.000"
                        />
                      </td>
                      <td className="p-0" style={{ width: "100px" }}>
                        <input
                          type="text"
                          value={row.nwt}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleTableRowChange(row.id, "nwt", value);
                            }
                          }}
                          className="form-control border-0 rounded-0 text-end"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            backgroundColor: "transparent",
                            width: "100%",
                            transition: "background-color 0.2s",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#fff";
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                          autoComplete="off"
                          placeholder="0.000"
                        />
                      </td>
                      <td className="p-0" style={{ width: "100px" }}>
                        <input
                          type="text"
                          value={row.touch}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleTableRowChange(row.id, "touch", value);
                            }
                          }}
                          className="form-control border-0 rounded-0 text-end"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            backgroundColor: "transparent",
                            width: "100%",
                            transition: "background-color 0.2s",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#fff";
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                          autoComplete="off"
                          placeholder="0.00"
                        />
                      </td>
                      <td className="p-0" style={{ width: "100px" }}>
                        <input
                          type="text"
                          value={row.fine_wt}
                          readOnly
                          className="form-control border-0 rounded-0 text-end bg-light"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            width: "100%",
                          }}
                          placeholder="0.000"
                        />
                      </td>
                      <td className="p-0" style={{ width: "120px" }}>
                        <input
                          type="text"
                          value={row.total_amt}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || /^\d*\.?\d*$/.test(value)) {
                              handleTableRowChange(row.id, "total_amt", value);
                            }
                          }}
                          className="form-control border-0 rounded-0 text-end"
                          style={{
                            fontSize: "0.85rem",
                            padding: "0.4rem 0.5rem",
                            backgroundColor: "transparent",
                            width: "100%",
                            transition: "background-color 0.2s",
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = "#fff";
                            handleTotalAmtFocus(row.id);
                          }}
                          onBlur={(e) => {
                            e.target.style.backgroundColor = "transparent";
                          }}
                          autoComplete="off"
                          placeholder="0.00"
                        />
                      </td>
                    </tr>
                  ))}
                  {/* Add Totals Row */}
                  <tr
                    style={{
                      backgroundColor: "#f8f9fa",
                      position: tableRows.length > 6 ? "sticky" : undefined,
                      bottom: tableRows.length > 6 ? 0 : undefined,
                      zIndex: tableRows.length > 6 ? 5 : undefined,
                    }}
                  >
                    <td className="p-0" style={{ width: "40px" }}>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          Total
                        </span>
                      </div>
                    </td>
                    <td className="p-0"></td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableRows.reduce((sum, row) => {
                            const pcs = parseNumericValue(row.pcs);
                            return sum + (isNaN(pcs) ? 0 : pcs);
                          }, 0)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0"></td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableRows
                            .reduce((sum, row) => {
                              const gwt = parseNumericValue(row.gwt);
                              return sum + (isNaN(gwt) ? 0 : gwt);
                            }, 0)
                            .toFixed(3)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableRows
                            .reduce((sum, row) => {
                              const lwt = parseNumericValue(row.lwt);
                              return sum + (isNaN(lwt) ? 0 : lwt);
                            }, 0)
                            .toFixed(3)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {tableRows
                            .reduce((sum, row) => {
                              const nwt = parseNumericValue(row.nwt);
                              return sum + (isNaN(nwt) ? 0 : nwt);
                            }, 0)
                            .toFixed(3)}
                        </span>
                      </div>
                    </td>
                    <td className="p-0"></td>
                    <td className="p-0"></td>
                    <td className="p-0" style={{ backgroundColor: "#fff" }}>
                      <div
                        className="d-flex align-items-center justify-content-end px-2"
                        style={{ height: "38px" }}
                      >
                        <span
                          style={{ fontSize: "0.85rem", fontWeight: "600" }}
                        >
                          {totalAmount.toFixed(2)}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <PaymentSection
              paymentRows={paymentRows}
              onPaymentRowsChange={setPaymentRows}
              paymentTypes={paymentTypes}
              bankAccounts={bankAccounts}
              excludedPayModes={URD_EXCLUDED_PAY_MODES}
              showCashPaid={false}
              payableRows={payableRows}
              onPayableRowsChange={setPayableRows}
              note={note}
              onNoteChange={setNote}
              showDiscount={false}
              finalAmount={totalAmount.toFixed(2)}
              gstPercentage={gstPercentage}
              onGstPercentageChange={setGstPercentage}
              gstAmount={calculateGstAmount().total.toFixed(2)}
              roundOffAmount={getDisplayRoundOff()}
              onRoundOffChange={handleRoundOffChange}
              grandTotal={grandTotalValue.toFixed(2)}
              totalPaid={totalPaidValue.toFixed(2)}
              payableAmount={payableAmountValue.toFixed(2)}
              remainingAmount={remainingAmount.toFixed(2)}
              followUpDate={followUpDate}
              onFollowUpDateChange={setFollowUpDate}
              buttonClass={buttonClass}
              cardClass={cardClass}
              buttonTableStyle={buttonTableStyle}
            />

            {/* Submit button at the bottom */}
            {!isViewOnly && (
              <div className="row mt-4">
                <div className="col-12">
                  <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
                    <Button
                      variant="primary"
                      onClick={handleSave}
                      disabled={isSaving}
                    >
                      {isSaving ? "Updating..." : "Update"}
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditOldPurchase;
